module.exports = "<div class=\"modal-header\">\n    <h4 class=\"modal-title pull-left\">{{title}}</h4>\n  </div>\n  <div class=\"modal-body\">\n    <div >\n        <table2 [(options)]=\"gridOptions\">\n        </table2>\n    </div>\n  </div>\n  <div class=\"modal-footer\">\n    <button type=\"button\" class=\"btn btn-primary pull-left\" (click)=\"bsModalRef.hide()\">Close</button>\n    \n  </div>\n    \n  \n  "


//////////////////
// WEBPACK FOOTER
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/OrderwiseReport/SalesOrderdetails.html
// module id = ../../../../../src/app/components/report/OrderwiseReport/SalesOrderdetails.html
// module chunks = main